import {
  Directive,
  OnInit,
} from '@angular/core';
import { iif } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddressStorageService } from '@pe/checkout/storage';
import { GetPaymentOptions, PaymentState } from '@pe/checkout/store';

import { AbstractPaymentContainer } from '../models';
import { PAYMENT_OPTION_DATA, PAYMENT_SETTINGS } from '../tokens';

import { AbstractContainerComponent } from './abstract-container.component';

@Directive()
export abstract class AbstractPaymentContainerComponent
  extends AbstractContainerComponent
  implements OnInit, AbstractPaymentContainer {

  protected addressStorageService = this.injector.get(AddressStorageService);
  private readonly paymentSettings = this.injector.get(PAYMENT_SETTINGS, null, {
    optional: true,
  });

  protected paymentOptionData = this.injector.get(PAYMENT_OPTION_DATA, null, {
    optional: true,
  });

  public nodeFormOptions$ = iif(
    () => !!this.paymentOptionData,
    this.store.select(PaymentState).pipe(
      map((state) => {
        const { connectionId, paymentMethod } = this.paymentOptionData;

        return state[paymentMethod][connectionId]?.formOptions;
      })
    ),
    this.store.select(PaymentState.options)
  );

  ngOnInit(): void {
    this.loadFormOptions();
  }

  private loadFormOptions(): void {
    const { connectionId, paymentMethod } = this.paymentOptionData ?? {};
    const nodeFormOptions = paymentMethod && connectionId
      ? this.store.selectSnapshot(PaymentState)[paymentMethod][connectionId]?.formOptions
      : this.store.selectSnapshot(PaymentState.options);

    if (this.paymentSettings?.hasNodeOptions
      && !nodeFormOptions
    ) {
      this.store.dispatch(
        new GetPaymentOptions(this.paymentOptionData, this.paymentSettings.doNotStoreFormOptions)
      );
    }
  }
}
